/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-alert */
import React, { useCallback, useEffect, useState } from 'react';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { Button } from '@uhg-abyss/web/ui/Button';
import { API } from '@src/api';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { memberInContextAtom, loggedInAdvocateAtom } from '@src/global-state';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useAtom } from 'jotai';
import { RadioGroup, RadioGroupDefaultProps } from '@uhg-abyss/web/ui/RadioGroup';
import { trimZipcodeToFiveDigits } from '@repo/utils';
import { config } from '@uhg-abyss/web/tools/config';
import { AssessmentHeader } from '@src/common/AssessmentHeader';
import { Dropdown } from './Type1_dropdown_textbox';
import { RadioDropdown } from './Type7_radio_dropdown';
import { CheckboxGroupQtn } from './Type4_checkbox_question';
import { RadioGroupQtn } from './Type3_radiogroup_question';
import { RadioTextBox } from './Type5_radio_textbox';
import { CheckBoxTextBox } from './Type6_checkbox_textbox';
import { getFeatureFlagsFromStorage } from '@src/utills/storage';
// import screeningQuestions from './mockQuestions.json';

export const SdohScreenerQuestions = () => {
  const { navigate } = useRouter();
  let getQuestionsApiResponse;
  const [memberInContext, setMemberInContext] = useAtom(memberInContextAtom);
  const [loggedInAdvocate, setLoggedInAdvocate] = useAtom(loggedInAdvocateAtom);
  const [assessmentId, setAssessmentId] = useState();
  const [assessmentName, setAssessmentName] = useState();
  const [hideQuestions, setHideQuestions] = useState(false);
  const [showDeclingConsent, setShowDeclingConsent] = useState(false);
  const featureFlags = getFeatureFlagsFromStorage();
  const [questions, setQuestions] = useState();
  const getQuestions = useCallback(() => {}, []);

  const form = useForm({});
  const onSkipAssessmentClick = async () => {
    if (form.getValues('does-consent') === 'no') {
      const payload = {
        memberId: memberInContext?.member_id,
        zipCode: memberInContext?.addrZipCode,
        reason: form.getValues('does-not-consent'),
      };

      await API.skipAssessment(payload).then(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        async (data: any) => {
        },
        (err) => {
        }
      );
      navigate(
        `/search?zipcode=${trimZipcodeToFiveDigits(
          memberInContext?.addrZipCode ?? ''
        )}`
      );
    } else {
      setShowDeclingConsent(true);
    }
  };

  useEffect(() => {
    if (
      (memberInContext?.ifp && featureFlags?.agent_ifp?.enabled) ||
      memberInContext?.lineOfBusiness === 'E&I'
    ) {
      const payload = {
        assessmentId: 6,
      };

      API.getQuestionsBasedOnAssesmentID(payload).then(
        async (data: any) => {
          getQuestionsApiResponse = data?.data.questions;
          setQuestions(getQuestionsApiResponse);
          setAssessmentId(data?.data.assessmentId);
          setAssessmentName(data?.data.assessmentName);
        },
        (err) => {
        }
      );
    } else {
      const payload = {
        zipcode: memberInContext?.addrZipCode,
      };

      API.getQuestionsForQuestionnaire(payload).then(
        async (data: any) => {
          getQuestionsApiResponse = data?.data.questions;
          setQuestions(getQuestionsApiResponse);
          setAssessmentId(data?.data.assessmentId);
          setAssessmentName(data?.data.assessmentName);
        },
        (err) => {
        }
      );
    }
  }, [memberInContext?.addrZipCode || memberInContext?.ifp]);

  getQuestions();

  questions?.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });

  const loadUI = useCallback((questionTypeId, qstn, index) => {
    switch (questionTypeId) {
      case '1':
        return <Dropdown key={index} serial={index + 1} qstn={qstn} />;
      // case '2':
      //   return <MultiSelect key={index} serial={index + 1} qstn={qstn} />;
      case '3':
        return <RadioGroupQtn key={index} serial={index + 1} qstn={qstn} />;
      case '4':
        return (
          <CheckboxGroupQtn
            key={index}
            serial={index + 1}
            qstn={qstn}
            form={form}
          />
        );
      case '5':
        return <RadioTextBox key={index} serial={index + 1} qstn={qstn} />;
      case '6':
        return (
          <CheckBoxTextBox
            key={index}
            serial={index + 1}
            qstn={qstn}
            form={form}
          />
        );
      case '7':
        return <RadioDropdown key={index} serial={index + 1} qstn={qstn} />;
      default:
        return null; // You might want to return something else here//
    }
  }, []);

  const fetchParseType3 = (ques, optionValueId) => {
    let res;
    Object.keys(ques?.options).forEach((i) => {
      if (ques?.options[i]?.values[0].id === optionValueId) {
        res = {
          questionId: ques?.questionId,
          questionTypeId: ques?.questionTypeId,
          selectedOptions: [
            {
              optionId: ques?.options[i]?.id,
              freeTextValue: null,
              optionValueId: ques?.options[i]?.values[0].id,
            },
          ],
        };
        return res;
      }
    });
    return res;
  };

  const fetchParseType4 = (ques, optionValueId) => {
    const selectedRes = [{}];
    let i = 0;
    Object.keys(ques?.options).forEach((ind) => {
      if (optionValueId.includes(ques?.options[ind]?.values[0].id)) {
        selectedRes[i] = {
          optionId: ques?.options[ind]?.id,
          freeTextValue: null,
          optionValueId: ques?.options[ind]?.values[0].id,
        };
        i += 1;
      }
    });
    const res = {
      questionId: ques?.questionId,
      questionTypeId: ques?.questionTypeId,
      selectedOptions: selectedRes,
    };

    return res;
  };

  const fetchParseType5 = (ques, optionValueId, additionalText) => {
    let res;
    Object.keys(ques?.options).forEach((i) => {
      if (ques?.options[i]?.values[0].id === optionValueId) {
        if (
          ques?.options[i]?.values[0]['additional text'] === null ||
          ques?.options[i]?.values[0]['additional text'] === undefined
        ) {
          res = {
            questionId: ques?.questionId,
            questionTypeId: ques?.questionTypeId,
            selectedOptions: [
              {
                optionId: ques?.options[i]?.id,
                freeTextValue: null,
                optionValueId: ques?.options[i]?.values[0].id,
              },
            ],
          };
          return res;
        }

        res = {
          questionId: ques?.questionId,
          questionTypeId: ques?.questionTypeId,
          selectedOptions: [
            {
              optionId: ques?.options[i]?.id,
              freeTextValue: additionalText,
              optionValueId: ques?.options[i]?.values[0].id,
            },
          ],
        };
        // return res;
      }
    });
    return res;
  };

  const fetchParseType6 = (ques, optionValueId, additionalText) => {
    const selectedRes = [{}];
    let i = 0;
    Object.keys(ques?.options).forEach((ind) => {
      if (optionValueId.includes(ques?.options[ind]?.values[0].id)) {
        if (
          ques?.options[ind]?.values[0]['additional text'] === null ||
          ques?.options[ind]?.values[0]['additional text'] === undefined
        ) {
          selectedRes[i] = {
            optionId: ques?.options[ind]?.id,
            freeTextValue: null,
            optionValueId: ques?.options[ind]?.values[0].id,
          };
          i += 1;
        } else {
          selectedRes[i] = {
            optionId: ques?.options[ind]?.id,
            freeTextValue: additionalText,
            optionValueId: ques?.options[ind]?.values[0].id,
          };
          i += 1;
        }
      }
    });
    const res = {
      questionId: ques?.questionId,
      questionTypeId: ques?.questionTypeId,
      selectedOptions: selectedRes,
    };
    return res;
  };

  const fetchParseType7 = (ques, optionValueId, additionalText) => {
    let res;

    if (optionValueId === 'Yes') {
      Object.keys(ques?.options[1]?.values).forEach((i) => {
        if (ques?.options[1]?.values[i]?.id === additionalText) {
          res = {
            questionId: ques?.questionId,
            questionTypeId: ques?.questionTypeId,
            selectedOptions: [
              {
                optionId: ques?.options[1]?.id,
                freeTextValue: null,
                optionValueId: ques?.options[1]?.values[i].id,
              },
            ],
          };
          return res;
        }
      });
    } else {
      Object.keys(ques?.options).forEach((i) => {
        if (ques?.options[i]?.values[0].id === optionValueId) {
          res = {
            questionId: ques?.questionId,
            questionTypeId: ques?.questionTypeId,
            selectedOptions: [
              {
                optionId: ques?.options[i]?.id,
                freeTextValue: null,
                optionValueId: ques?.options[i]?.values[0].id,
              },
            ],
          };
        }
      });
    }
    return res;
  };

  const savePayload = [];
  let saveRespPayload = {};

  const updateAnswers = (response, additionalText) => {
    const array_of_qids = Object.keys(questions).map((f) => {
      return questions[f].questionId;
    });
    Object.keys(response).forEach((i) => {
      const index = array_of_qids.indexOf(response[i].questionId);
      const question_obj = questions[index];

      const array_of_aqids = Object.keys(additionalText).map((f) => {
        return additionalText[f].questionId;
      });

      Object.keys(response).forEach((i) => {
        if (array_of_aqids.includes(response[i].questionId)) {
          const index = array_of_aqids.indexOf(response[i].questionId);
          response[i].text = additionalText[index].additionalText;
        }
      });

      if (question_obj.questionTypeId === '3') {
        savePayload.push(
          fetchParseType3(question_obj, response[i].optionValueId)
        );
      } else if (question_obj.questionTypeId === '4') {
        savePayload.push(
          fetchParseType4(question_obj, response[i].optionValueId)
        );
      } else if (question_obj.questionTypeId === '5') {
        savePayload.push(
          fetchParseType5(
            question_obj,
            response[i].optionValueId,
            response[i].text
          )
        );
      } else if (question_obj.questionTypeId === '6') {
        savePayload.push(
          fetchParseType6(
            question_obj,
            response[i].optionValueId,
            response[i].text
          )
        );
      } else if (question_obj.questionTypeId === '7') {
        savePayload.push(
          fetchParseType7(
            question_obj,
            response[i].optionValueId,
            response[i].text
          )
        );
      }
    });

    const roleArr = loggedInAdvocate?.roles;
    let userSecureRole = roleArr?.[0];
    for (let index = 1; index < roleArr?.length; index++) {
      userSecureRole = `${userSecureRole}, ${roleArr?.[index]}`;
    }

    saveRespPayload = {
      zipcode: memberInContext?.addrZipCode,
      questionsResponse: savePayload,
      memberFirstName: memberInContext?.first_name,
      memberLastName: memberInContext?.last_name,
      screenedByUserId: loggedInAdvocate?.user_name_id,
      screenedByUserName: `${loggedInAdvocate?.last_name}, ${loggedInAdvocate?.first_name}`,
      consumerId: memberInContext?.ConsumerId,
      lob: memberInContext?.lineOfBusiness,
      secureRole: userSecureRole,
      memberId: memberInContext?.member_id,
      userId: 'U1',
      assessmentId,
      assessmentName,
      enterpriseId: memberInContext?.enterpriseIndividualIdentifier,
      dob: memberInContext?.DOB,
    };
  };

  const response = {};
  const additionalText = {};
  let indx = 0;

  const displayQuestions = () => {
    setHideQuestions(false);
  };

  const onSubmit = async (data) => {

    Object.keys(data).map((e, i) => {
      if (e.startsWith('qstn')) {
        response[i] = {
          questionId: e.split('-').pop(),
          optionValueId: data[e],
          text: null,
        };
      } else {
        additionalText[indx] = {
          questionId: e.split('-').pop(),
          additionalText: data[e],
        };
        indx += 1;
      }
    });

    updateAnswers(response, additionalText);

await API.saveQuestionsForQuestionnaire(saveRespPayload).then(
      // eslint-disable-next-line @typescript-eslint/no-shadow
      async (data: any) => {
        // ,
        navigate(`/identified-needs/${data.data.memberScreeningId}`);
      },
      (err) => {
      }
    );
  };

  useEffect(() => {
    // Feature flag for 'CONSENT' has been true in all environments for several months,
    // but I don't have context about what it does so I am leaving this pointless useEffect check
    // for someone else to deal with.
    setHideQuestions(true);
  }, []);

  return (
    <React.Fragment>
      <div>
        <div style={{ paddingLeft: '2%' }}>
          <AssessmentHeader />
        </div>
        <div style={{ paddingLeft: '5.5%', paddingRight: '5.5%' }}>
          <div style={{ padding: '0rem 5rem 1rem 5rem' }} />
          {hideQuestions && (
            <div>
              <div>
                <Heading size="md">
                  Privacy Policy Script for Advocate
                </Heading>
                <br />
                <Heading size="sm">Advocate script:</Heading>
                <Text>
                  How we protect your personal information and social needs
                  data.
                  <br />
                  <br />
                  We receive information about you. This may include your race,
                  ethnicity, language you speak, gender <br />
                  identity, and sexual orientation. This data and other personal
                  information about you is Protected <br />
                  Health Information (PHI). We may share this information with
                  your health care providers as part of <br />
                  treatment, payment, and operations in meeting your health care
                  needs. Examples of how we may use <br />
                  it to improve the services we provide include:
                  <br />
                  <br />
                  <p>• Finding gaps in care.</p>
                  <p>• Helping you in other languages.</p>
                  <p>• Creating programs that meet your needs.</p>
                  <p>
                    • Telling your health care providers what language you
                    speak.
                  </p>
                  <br />
                  We do not use this data to deny coverage or limit benefits. We
                  protect this information in the same way we protect all other
                  <br />
                  PHI. Access is restricted to those employees who need to use
                  it. Our buildings and computers are secured. Computer
                  <br />
                  passwords and other system protections keep your data safe.
                  <br />
                  <br />
                  If you want more information about how we protect your
                  privacy, view the full policy within the member handbook.
                </Text>
              </div>
              <br />
              <Heading size="md">
                Screening Script for Advocate and Consent Collection Question
              </Heading>
              <Heading size="sm">Advocate script:</Heading>
              <Text>
                "We have an assessment that will help us understand your
                potential social needs. Once your social <br />
                needs are identified, we can potentially connect you to
                community based resources that can help <br />
                improve these areas of your life. Your participation is
                completely voluntary. Your decision to <br />
                participate or not won't affect the healthcare services you
                receive. We highly respect your privacy and <br />
                all information shared will be kept confidential. Would you be
                comfortable with us conducting this <br />
                assessment?"
              </Text>
              <br />
              <br />
              <Text style={{ color: '#002677', fontWeight: 'bold' }}>
                *It's important to reassure them that they have the right to
                decline or stop the assessment at any point <br />
                without any negative impact on their care.
              </Text>
              <br />
              <br />

              {/* <FormProvider>Consent form goes here</FormProvider>
          If form is successful, show the next form. */}
              <FormProvider id="consentForm" state={form}>
                <RadioGroup
                  label={<strong>Do you consent to completing this social needs assessment?</strong>}
                  model="does-consent"
                  validators={{ required: true }}
                >
                  <RadioGroup.Column>
                    <RadioGroup.Radio label="Yes, I do consent" value="yes" />
                    <RadioGroup.Radio
                      label="No, I do not provide my consent"
                      value="no"
                    />
                  </RadioGroup.Column>
                </RadioGroup>
              </FormProvider>
              <br />
              <br />
              {form.getValues('does-consent') === 'no' && (
                <div>
                  <Heading size="md">Decline Screening</Heading>
                  <Heading size="sm">Advocate script:</Heading>
                  <br />
                  <Text>
                    “You are declining the screening, may I ask your reason?”
                    <br />
                  </Text>

                  <FormProvider id="consentForm" state={form}>
                    <br />
                    <RadioGroup
                      label={<strong>Member's reason for declining:</strong>}
                      model="does-not-consent"
                      validators={{ required: true }}
                    >
                      <RadioGroup.Column>
                        <RadioGroup.Radio
                          label="Member did not provide reason"
                          value="Member did not provide reason"
                        />
                        <RadioGroup.Radio
                          label="Member does not believe screener will be helpful"
                          value="Member does not believe screener will be helpful"
                        />
                        <RadioGroup.Radio
                          label="Cultural or religious beliefs prevent member from participating"
                          value="Cultural or religious beliefs prevent member from participating"
                        />
                      </RadioGroup.Column>
                    </RadioGroup>
                  </FormProvider>
                </div>
              )}
              <Grid.Col span={{ xs: 12, md: 6, lg: 2 }}>
                <Layout.Group
                  style={{
                    paddingTop: '25px',
                  }}
                >
                  <Button
                    data-cy="skip_screener"
                    variant="outline"
                    type="submit"
                    style={{ marginTop: 15 }}
                    isDisabled={
                      form.watch('does-consent') !== 'no' ||
                      !form.watch('does-not-consent')?.length
                    }
                    onClick={() => {
                      return onSkipAssessmentClick();
                    }}
                  >
                    Skip Screener
                  </Button>
                  <Button
                    type="submit"
                    style={{ marginTop: 15 }}
                    isDisabled={form.watch('does-consent') !== 'yes'}
                    onClick={() => {
                      return displayQuestions();
                    }}
                  >
                    Start Screening
                  </Button>
                </Layout.Group>
              </Grid.Col>

              <br />
              <br />
              <br />
            </div>
          )}

          {!hideQuestions && (
            <div>
              <Heading
                data-cy="screener_questions"
                size="sm"
                style={{
                  marginTop: '24px',
                }}
              >
                Screener questions (All questions are required)
              </Heading>
              <br />
              <FormProvider id="questionnaire" state={form} onSubmit={onSubmit}>
                <div style={{ marginTop: '5px' }} />
                {questions?.map((mp, index) => {
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={index}>
                      {loadUI(mp.questionTypeId, mp, index)}
                      <br />
                    </div>
                  );
                })}
                <Button
                  data-cy="button-screening-complete"
                  type="submit"
                  style={{ marginTop: 12, marginBottom: 12 }}
                >
                  Submit
                </Button>
              </FormProvider>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
